import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-405e3fd2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loader"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lds-default" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_3 = { class: "loader-wrapper__title" }
const _hoisted_4 = {
  key: 1,
  class: "load-success"
}
const _hoisted_5 = { class: "load-success__title" }
const _hoisted_6 = { class: "load-success__text" }


import { PromoLoaderInterface } from '~/types/promoLoader.interface';
import useLoaderPopup from '@/composables/loaderPopupState';


export default /*#__PURE__*/_defineComponent({
  props: {
    isSuccess: null,
    data: null
  },
  setup(__props: any) {



const { show } = useLoaderPopup();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["loader-wrapper", { 'loader-wrapper-show': !!_unref(show) }])
  }, [
    (!__props.isSuccess)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("h2", _hoisted_3, _toDisplayString(__props.data.loadingText), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(__props.data.successText), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(__props.data.welcomeText), 1)
        ]))
  ], 2))
}
}

})